import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { POST_URL } from '@utils/api/endpoints.ts';
import { AxiosError } from 'axios';
import { BaseError } from '@utils/types/shared/base.ts';

export interface ChangePasswordPayload {
  new_password: string;
  old_password: string;
  confirm_new_password?: string;
}

export async function changePassword(
  passwordData: ChangePasswordPayload
): Promise<void> {
  await Axios.post(POST_URL().updatePassword, passwordData);
}

export function useChangePassword() {
  const queryClient = useQueryClient();

  return useMutation<void, AxiosError<BaseError>, ChangePasswordPayload>(
    (passwordData: ChangePasswordPayload) => changePassword(passwordData),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries('user');
      },
      useErrorBoundary: false
    }
  );
}
